/**
 * @override
 * 自定义积木，要采用统一样式，必须在定义积木样式，
 * 设置output:'String/Number/Boolean/...'
 *
 */
import Blockly from 'blockly'

// 事件类别积木
Blockly.Blocks.gta_ai_event_1 = {
  init: function() {
    this.appendDummyInput().appendField('  开始进入Python的世界')
    // this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_1'])
    this.setOutput(true, 'String')
  },
}
Blockly.Python.gta_ai_event_1 = function() {
  return ' #开始进入Python的世界\n'
}
let helpdocumentEvent = 'TEXT_PRINT_TOOLTIP'
// 打印 输出 text_print
Blockly.Blocks['gta_ai_event_2'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('打印"')
      .appendField(new Blockly.FieldTextInput('Hello'), 'TEXT')
      .appendField('"')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('打印')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_2'])
  },
}

Blockly.Python['gta_ai_event_2'] = function(block) {
  var msg = block.getFieldValue('TEXT')
  if (/\\/g.test(msg)) {
    msg = msg.replace(/\\/g, '/')
  }
  if (/"/g.test(msg)) {
    msg = msg.replace(/"/g, '\\"')
  }
  // if(msg)
  return 'print(" ' + msg + '")\n'
}

Blockly.Blocks.gta_ai_event_3 = {
  init: function() {
    this.appendDummyInput()
      .appendField('注释')
      .appendField(new Blockly.FieldTextInput('注释内容'), 'NAME')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_3'])
    // this.setOutput(true, "String");
  },
}
Blockly.Python.gta_ai_event_3 = function(a) {
  var text_name = a.getFieldValue('NAME')
  // TODO: Assemble JavaScript into code variable.
  var code = '#' + text_name + '\n'
  return code
}

Blockly.Blocks.gta_ai_event_4 = {
  init: function() {
    this.appendDummyInput()
      .setAlign(Blockly.ALIGN_RIGHT)
      .appendField(new Blockly.FieldMultilineInput('# 输入代码并执行'), 'NAME')
    this.setOutput(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_4'])
    this.setOutput(true, 'String')
  },
}
Blockly.Python.gta_ai_event_4 = function(a) {
  var text_name = a.getFieldValue('NAME')
  // TODO: Assemble JavaScript into code variable.
  var code = text_name
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

Blockly.Blocks.gta_ai_event_5 = {
  init: function() {
    this.appendDummyInput()
      .setAlign(Blockly.ALIGN_RIGHT)
      .appendField(new Blockly.FieldMultilineInput('# 输入代码并执行'), 'NAME')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_5'])
    // this.setOutput(true, "String");
  },
}
Blockly.Python.gta_ai_event_5 = function(a) {
  var text_name = a.getFieldValue('NAME')
  // TODO: Assemble JavaScript into code variable.
  var code = text_name + '\n'
  return code
}

Blockly.Blocks.gta_ai_event_6 = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .appendField('显示')
      .appendField('')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_6'])
  },
}
Blockly.Python.gta_ai_event_6 = function(a) {
  var b = Blockly.Python.valueToCode(a, 'NAME', Blockly.Python.ORDER_NONE)
  if (b != '...') {
    return 'GTAPrint(' + b + ')\n'
  }
  return 'GTAPrint()\n'
}

Blockly.Blocks.gta_ai_event_print = {
  init: function() {
    this.appendDummyInput().appendField('打印 ')
    this.appendValueInput('NAME').setCheck(null)
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_print'])
    // this.setOutput(true, "String");
  },
}
Blockly.Python.gta_ai_event_print = function(a) {
  var val = Blockly.Python.valueToCode(a, 'NAME', Blockly.Python.ORDER_NONE)
  if (val != '...') {
    return 'print(' + val + ')\n'
  } else {
    return 'print()\n'
  }
}
Blockly.JavaScript.gta_ai_event_print = function(a) {
  var val = Blockly.JavaScript.valueToCode(a, 'NAME', Blockly.JavaScript.ORDER_NONE)
  if (val != '...') {
    return 'window.alert(' + val + ')\n'
  } else {
    return '\n'
  }
}

Blockly.Blocks.gta_ai_event_7 = {
  init: function() {
    this.appendDummyInput()
      .setAlign(Blockly.ALIGN_RIGHT)
      .appendField('显示“')
    this.appendDummyInput().appendField(new Blockly.FieldTextInput(''), 'NAME')
    this.appendDummyInput().appendField('”，')
    this.appendValueInput('NAME_2')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_7'])
  },
}
Blockly.Python.gta_ai_event_7 = function(a) {
  var text_name = a.getFieldValue('NAME')
  text_name = text_name.trim()
  var value_name = Blockly.Python.valueToCode(
    a,
    'NAME_2',
    Blockly.Python.ORDER_ATOMIC
  )
  // 反斜杠转义
  if (/\\/g.test(text_name)) {
    text_name = text_name.replace(/\\/g, '/')
  }
  // 单引号转义
  if (/'/g.test(text_name)) {
    text_name = text_name.replace(/'/g, "\\'")
  }
  // 双引号转义
  if (/"/g.test(text_name)) {
    text_name = text_name.replace(/"/g, '\\\\"')
  }
if(text_name!="..."){
  let b = "'" + text_name + "'," + value_name
  return 'GTAPrint(' + b + ')\n'
}else{
  let b = value_name
  return 'GTAPrint(' + b + ')\n'
}
 
}

Blockly.Blocks.gta_ai_event_8 = {
  init: function() {
    this.appendDummyInput()
      .appendField('显示“')
      .appendField(new Blockly.FieldTextInput(''), 'NAME')
      .appendField('”')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_8'])
    // this.setOutput(true, "String");
  },
}
Blockly.Python.gta_ai_event_8 = function(a) {
  var text_name = a.getFieldValue('NAME')
  var value_name = Blockly.Python.valueToCode(
    a,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  text_name = text_name.trim()
  // 反斜杠转义
  if (/\\/g.test(text_name)) {
    text_name = text_name.replace(/\\/g, '/')
  }
  // 单引号转义
  if (/'/g.test(text_name)) {
    text_name = text_name.replace(/'/g, "\\'")
  }
  // 双引号转义
  if (/"/g.test(text_name)) {
    text_name = text_name.replace(/"/g, '\\\\"')
  }

  var b = "'" + text_name + "'," + value_name
  // debugger;
  return 'GTAPrint(' + b + ')\n'
}

// 控制大小
Blockly.Blocks.gta_ai_event_9 = {
  init: function() {
    this.appendDummyInput().appendField('设置')
    this.appendValueInput('imageSrc').setCheck(null)
    this.appendDummyInput().appendField('大小')
    this.appendValueInput('imageSize').setCheck('Number')
    this.appendDummyInput().appendField('%')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_9'])
    // this.setOutput(true, "String");
  },
}
Blockly.Python.gta_ai_event_9 = function(a) {
  var imageSrc = Blockly.Python.valueToCode(
    a,
    'imageSrc',
    Blockly.Python.ORDER_ATOMIC
  )
  var imageSize = Blockly.Python.valueToCode(
    a,
    'imageSize',
    Blockly.Python.ORDER_ATOMIC
  )
  // TODO:
  var b = '' + imageSrc + ',' + imageSize
  return 'GTASetImageSize(' + b + ')\n'
}

// 控制大小
Blockly.Blocks.gta_ai_event_9_1 = {
  init: function() {
    this.appendDummyInput().appendField('显示')
    this.appendValueInput('imageSrc').setCheck(null)
    this.appendDummyInput().appendField('  大小')
    this.appendValueInput('imageSize').setCheck('Number')
    this.appendDummyInput().appendField('%')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_9_1'])
    // this.setOutput(true, "String");
  },
}
Blockly.Python.gta_ai_event_9_1 = function(a) {
  var imageSrc = Blockly.Python.valueToCode(
    a,
    'imageSrc',
    Blockly.Python.ORDER_ATOMIC
  )
  var imageSize = Blockly.Python.valueToCode(
    a,
    'imageSize',
    Blockly.Python.ORDER_ATOMIC
  )
  // TODO:
  var b = '' + imageSrc + ',' + imageSize
  return 'GTASetImageSize(' + b + ')\n'
}



Blockly.Blocks['gta_ai_event_10'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('运行分区划分为')
      .appendField(
        new Blockly.FieldDropdown([
          ['1', '1'],
          ['4', '4'],
          ['9', '9'],
        ]),
        'partNum'
      )
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_10'])
  },
}
Blockly.Python['gta_ai_event_10'] = function(block) {
  var partnum = block.getFieldValue('partNum')

  partnum = Number(partnum)
  return 'partNum=' + partnum + '\n'
}

Blockly.Blocks.gta_ai_event_11 = {
  init: function() {
    this.appendDummyInput()
      .appendField('在分区')
      .appendField(
        new Blockly.FieldDropdown([
          ['1', '1'],
          ['2', '2'],
          ['3', '3'],
          ['4', '4'],
          ['5', '5'],
          ['6', '6'],
          ['7', '7'],
          ['8', '8'],
          ['9', '9'],
        ]),
        'partIndex'
      )
      .appendField('运行结果')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_11'])
  },
}

Blockly.Python.gta_ai_event_11 = function(block) {
  var partIndex = block.getFieldValue('partIndex')
  partIndex = Number(partIndex)
  return 'def part' + partIndex + '():' + '\n'
  // return "partIndex=" + partIndex + "\n";
}
Blockly.Blocks.gta_ai_event_12 = {
  init: function() {
    this.appendDummyInput()
      .appendField('分区')
      .appendField(
        new Blockly.FieldDropdown([
          ['1', '1'],
          ['2', '2'],
          ['3', '3'],
          ['4', '4'],
          ['5', '5'],
          ['6', '6'],
          ['7', '7'],
          ['8', '8'],
          ['9', '9'],
        ]),
        'partIndex'
      )
      .appendField('标题为')
      .appendField(new Blockly.FieldTextInput('标题'), 'NAME')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_ai_event_12'])
  },
}
Blockly.Python.gta_ai_event_12 = function(block) {
  var partindex = block.getFieldValue('partIndex')
  var name = block.getFieldValue('NAME')
  return "partName=['" + partindex + "','" + name + "']\n"
}

// 人脸识别积木
// 年龄
// Blockly.Blocks.get_face_age = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物年龄");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_age = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='age',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 颜值
// Blockly.Blocks.get_face_beauty = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物颜值");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_beauty = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='beauty',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 性别
// Blockly.Blocks.get_face_gender = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物性别");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_gender = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='gender',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 表情
// Blockly.Blocks.get_face_expression = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物表情");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_expression = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='expression',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 脸型
// Blockly.Blocks.get_face_faceShape = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物脸型");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_faceShape = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='faceShape',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 情绪
// Blockly.Blocks.get_face_emotion = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物情绪");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_emotion = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='emotion',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 人种
// Blockly.Blocks.get_face_race = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人种");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_race = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='race',function=GTAFunGetFace,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 智能机械臂
// Blockly.Blocks.gta_fun_plc_color = {
//   init: function() {
//     this.appendDummyInput().appendField("颜色分拣");
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     // this.setColour("#5b91ff");
//     this.setTooltip("");
//     this.setHelpUrl("");
//     // this.setOutput(true, "String");
//   }
// };
// Blockly.Python.gta_fun_plc_color = function() {
//   return "GTAFunPLCColorBlock\n";
// };

// Blockly.Blocks.gta_fun_plc_follow = {
//   init: function() {
//     this.appendDummyInput().appendField("跟随夹取");
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//     // this.setOutput(true, "String");
//   }
// };
// Blockly.Python.gta_fun_plc_follow = function() {
//   return "GTAFunPLCFollowBlock\n";
// };

// Blockly.Blocks.gta_fun_plc_stack = {
//   init: function() {
//     this.appendDummyInput().appendField("叠罗汉");
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//     // this.setOutput(true, "String");
//   }
// };
// Blockly.Python.gta_fun_plc_stack = function() {
//   return "GTAFunPLCStackBlock\n";
// };

// Blockly.Blocks.get_face_age2 = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人物年龄");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_face_age2 = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     // "'age','GTAFunGetFace'",
//     name + ",attribute='age',function=GTAFunGetFace,width=,height=",
//     // "attribute='age',function='GTAFunGetFace'",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// //人体锚点识别
// Blockly.Blocks.get_body = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人体锚点");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_body = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='ok',function=GTAFunGetBody,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // 手势识别
// // 拳头
// Blockly.Blocks.get_hand_Fist = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的握拳手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_hand_Fist = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Fist',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // ok
// Blockly.Blocks.get_hand_ok = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的OK手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };

// Blockly.Python.get_hand_ok = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='OK',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // 作揖
// Blockly.Blocks.get_hand_Congratulation = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的作揖手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Congratulation = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Congratulation',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // 作别
// Blockly.Blocks.get_hand_Honour = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的作别手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Honour = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Honour',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 点赞
// Blockly.Blocks.get_hand_Thumb_up = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的点赞手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Thumb_up = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Thumb_up',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // Diss
// Blockly.Blocks.get_hand_Diss = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的diss手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Diss = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Thumb_down',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // Rock
// Blockly.Blocks.get_hand_Rock = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的rock手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Rock = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Rock',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // 竖中指
// Blockly.Blocks.get_hand_Insult = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的竖中指手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Insult = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Insult',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };
// // 人流数量
// Blockly.Blocks.get_hand_Count = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的人流数量");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Count = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Count',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // 数字
// Blockly.Blocks.get_hand_Number = {
//   init: function() {
//     this.appendDummyInput().appendField("识别");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("的数字手势");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.get_hand_Number = function(block) {
//   var name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   return [
//     name + ",attribute='Number',function=GTAFunGetHand,width=,height=",
//     Blockly.Python.ORDER_NONE
//   ];
// };

// // 无人小车
// // GTAFunDrive(angle,throttle,driveMode,recording)
// // 参数：throttle-1 ~1, 角度angle -1~1，driveMode:用户user，recording:true/false
// /* 默认速度0.22 */
// // 开启、关闭
// Blockly.Blocks.fun_drive_on = {
//   init: function() {
//     this.appendDummyInput()
//       .appendField("小车")
//       .appendField(
//         new Blockly.FieldDropdown([
//           ["开启", "true"],
//           ["关闭", "false"]
//         ]),
//         "NAME"
//       );
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.fun_drive_on = function(block) {
//   var name = block.getFieldValue("NAME");
//   if (name == "false") {
//     return "GTAFunDrive(0,0,'user','false')\n";
//   } else {
//     return "GTAFunDrive(0,0,'user','true')\n";
//   }
//   // return "GTAFunDrive(recording='" + name + "')\n";
// };

// // 前进、后退-0.22值可能需要调整
// Blockly.Blocks.fun_drive_forward = {
//   init: function() {
//     this.appendDummyInput()
//       .appendField("小车")
//       .appendField(
//         new Blockly.FieldDropdown([
//           ["前进", "-"],
//           ["后退", "+"]
//         ]),
//         "NAME"
//       )
//       .appendField(new Blockly.FieldNumber(0), "NAME2")
//       .appendField("cm/s");
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.fun_drive_forward = function(block) {
//   var name = block.getFieldValue("NAME");
//   var throttle = block.getFieldValue("NAME2"); //速度
//   throttle = Math.floor(((throttle * 0.228) / 30) * 100) / 100;
//   if (throttle >= 1) {
//     throttle = 1;
//   }
//   // debugger;
//   throttle = name == "-" ? eval(-throttle) : eval(throttle);
//   return "GTAFunDrive(0," + throttle + ",'user','true')\n";
// };

// // 角度 angle 值：-1~1;
// Blockly.Blocks.fun_drive_angle2 = {
//   init: function() {
//     this.appendDummyInput()
//       .appendField("小车")
//       .appendField(
//         new Blockly.FieldDropdown([
//           ["左转", "left"],
//           ["右转", "right"]
//         ]),
//         "NAME"
//       )
//       .appendField(
//         new Blockly.FieldDropdown([
//           ["15度", "0.333"],
//           ["30度", "0.667"],
//           ["45度", "1"]
//         ]),
//         "NAME2"
//       )
//       .appendField(new Blockly.FieldNumber(0, 0), "NAME3")
//       .appendField("cm/s");
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.fun_drive_angle2 = function(block) {
//   var name1 = block.getFieldValue("NAME");
//   var name2 = block.getFieldValue("NAME2");
//   var throttle = block.getFieldValue("NAME3");
//   var symbol = name1 == "left" ? "-" : "";
//   name2 = (symbol + name2).trim();

//   throttle = -Math.floor(((throttle * 0.228) / 30) * 100) / 100;
//   if (throttle <= -1) {
//     throttle = -1;
//   }
//   // debugger;
//   return "GTAFunDrive(" + name2 + "," + throttle + ",'user','true')\n";
//   // return "GTAFunDrive(angle='" + name2 + "')\n";
// };

// // 显示视频
// Blockly.Blocks.fun_drive_video = {
//   init: function() {
//     this.appendDummyInput().appendField("显示小车摄像头视频");
//     this.setPreviousStatement(true, null);
//     this.setNextStatement(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.fun_drive_video = function() {
//   return "GTAFunDrive(url='http://10.1.11.13:8887/video')\n";
// };

// // 速度;
// // Blockly.Blocks.fun_drive_speed = {
// //   init: function() {
// //     this.appendDummyInput()
// //       .appendField("控制小车速度为")
// //       .appendField(new Blockly.FieldNumber(0), "NAME")
// //       .appendField("cm/s");
// //     this.setPreviousStatement(true, null);
// //     this.setNextStatement(true, null);
// //     this.setStyle("event_blocks");
// //     this.setTooltip("");
// //     this.setHelpUrl("");
// //   }
// // };
// // Blockly.Python.fun_drive_speed = function(block) {
// //   var name = block.getFieldValue("NAME");
// //   // debugger;
// //   // return "GTAFunDrive(speed='" + name + "')\n";
// //   return "GTAFunDrive(speed='" + name + "')\n";
// // };

// // 我的模型积木

// //图像识别，图像转为文字
// Blockly.Blocks.img_exchangeTo_font = {
//   init: function() {
//     this.appendDummyInput().appendField("图像");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("转为文字");
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.img_exchangeTo_font = function(block) {
//   let reg_quot = /(?<=\().*(?=\))/; //去掉首尾的括号
//   var value_name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   // value_name = value_name.match(reg_quot);
//   // return value_name;
//   var code = "GTAFunOCRText(url=" + value_name + ")";
//   return [code, Blockly.Python.ORDER_NONE];
// };

// //语音识别，语音转为文字
// Blockly.Blocks.audio_exchangeTo_font = {
//   init: function() {
//     this.appendDummyInput().appendField("语音");
//     this.appendValueInput("NAME").setCheck(null);
//     this.appendDummyInput().appendField("转为文字");
//     this.setOutput(true, null);
//     this.setStyle("event_blocks");
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python.audio_exchangeTo_font = function(block) {
//   let reg_quot = /\(|\)/g; //去掉首尾的括号
//   var value_name = Blockly.Python.valueToCode(
//     block,
//     "NAME",
//     Blockly.Python.ORDER_ATOMIC
//   );
//   value_name = value_name.replace(reg_quot, "");
//   // return value_name;
//   var code = "GTAFunSpeechToText(url=" + value_name + ")";
//   return [code, Blockly.Python.ORDER_NONE];
// };

// //文字识别，文字转为语音
// Blockly.Blocks.font_exchangeTo_audio = {
//   init: function() {
//     this.appendDummyInput()
//       .appendField("文字")
//       .appendField(new Blockly.FieldTextInput("        "), "NAME")
//       .appendField("转为语音");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setColour(230);
//     this.setTooltip("");
//     this.setHelpUrl("");
//     this.setStyle("event_blocks");
//   }
// };
// Blockly.Python.font_exchangeTo_audio = function(block) {
//   let reg_quot = /\(|\)/g; //去掉首尾的括号
//   var value_name = block.getFieldValue("NAME");
//   value_name = value_name.trim();
//   // value_name = value_name.replace(reg_quot, "");
//   // return value_name;
//   var code = "GTAFunTextToSpeech(text='" + value_name + "')";
//   return [code, Blockly.Python.ORDER_NONE];
// };

// Blockly.Blocks.gta_trainedmodel_label_c92d4a9758a84d3aa40e6bf55d0f585a1 = {
//   init: function() {
//     this.appendDummyInput().appendField('"汽车"');
//     this.setOutput(true, null);
//     this.setColour(230);
//     this.setTooltip("");
//     this.setHelpUrl("");
//   }
// };
// Blockly.Python[
//   "gta_trainedmodel_label_5b22f739-a369-6c5c-3022-1859edf13fcd1"
// ] = function(a) {
//   var code = "'汽车'";
//   return [code, Blockly.Python.ORDER_FUNCTION_CALL];
// };

// 转为语音备份
// Blockly.Blocks.font_exchangeTo_audio = {
//   init: function() {
//     this.appendDummyInput()
//       .appendField("文字")
//       .appendField(new Blockly.FieldTextInput("        "), "NAME")
//       .appendField("转为语音");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setTooltip("");
//     this.setHelpUrl(Blockly.Msg['font_exchangeTo_audio']);
//     this.setStyle("basic_model_blocks");
//   }
// };
// Blockly.Python.font_exchangeTo_audio = function(block) {
//   let reg_quot = /\(|\)/g;
//   var value_name = block.getFieldValue("NAME");
//   value_name = value_name.trim();
//   var code = "GTAFunTextToSpeech(text='" + value_name + "')";
//   return [code, Blockly.Python.ORDER_NONE];
// };

// Blockly.Blocks.font_exchangeTo_audio_2 = {
//   init: function() {
//     this.appendDummyInput().appendField('文字')
//     this.appendValueInput('NAME')
//       .setCheck(null)
//       this.appendDummyInput().appendField('转为语音')
//     this.setInputsInline(true)
//     this.setOutput(true, null)
//     this.setTooltip('')
//     this.setHelpUrl(Blockly.Msg['font_exchangeTo_audio'])
//     this.setStyle('basic_model_blocks')
//   },
// }
// Blockly.Python.font_exchangeTo_audio_2 = function(block) {
//   let reg_quot = /\(|\)/g
//   var value_name= Blockly.Python.valueToCode(block, 'NAME', Blockly.Python.ORDER_NONE)
//   value_name = value_name.trim()
//   var code = "GTAFunTextToSpeech(text=" + value_name + ")"
//   return [code, Blockly.Python.ORDER_NONE]
// }

// Blockly.Blocks.font_exchangeTo_audio = {
//   init: function() {
//     this.appendDummyInput()
//       .appendField("文字")
//       .appendField(new Blockly.FieldTextInput("        "), "NAME")
//       .appendField("转为语音");
//     this.setInputsInline(true);
//     this.setOutput(true, null);
//     this.setColour(230);
//     this.setTooltip("");
//     this.setHelpUrl(Blockly.Msg['语音合成']);
//     this.setStyle("event_blocks");
//   }
// };
// Blockly.Python.font_exchangeTo_audio = function(block) {
//   let reg_quot = /\(|\)/g;
//   var value_name = block.getFieldValue("NAME");
//   value_name = value_name.trim();
//   var code = "GTAFunTextToSpeech(text='" + value_name + "')";
//   return [code, Blockly.Python.ORDER_NONE];
// };

// Blockly.Blocks.font_exchangeTo_audio_2 = {
//   init: function() {
//     this.appendDummyInput().appendField('文字')
//     this.appendValueInput('NAME')
//       .setCheck(null)
//       this.appendDummyInput().appendField('转为语音')
//     this.setInputsInline(true)
//     this.setOutput(true, null)
//     this.setTooltip('')
//     this.setHelpUrl(Blockly.Msg['font_exchangeTo_audio'])
//     this.setStyle('basic_model_blocks')
//   },
// }
// Blockly.Python.font_exchangeTo_audio_2 = function(block) {
//   let reg_quot = /(|)/g
//   var value_name= Blockly.Python.valueToCode(block, 'NAME', Blockly.Python.ORDER_NONE)
//   value_name = value_name.trim()
//   var code = 'GTAFunTextToSpeech(text=' + value_name + ')'
//   return [code, Blockly.Python.ORDER_NONE]
// }
